import { render, staticRenderFns } from "./TermsGroup.vue?vue&type=template&id=81cb1f02&scoped=true&"
import script from "./TermsGroup.vue?vue&type=script&lang=js&"
export * from "./TermsGroup.vue?vue&type=script&lang=js&"
import style0 from "./TermsGroup.vue?vue&type=style&index=0&id=81cb1f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cb1f02",
  null
  
)

export default component.exports